import { render, staticRenderFns } from "./GridIntroSection.vue?vue&type=template&id=45ba02c5"
import script from "./GridIntroSection.vue?vue&type=script&lang=ts"
export * from "./GridIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./GridIntroSection.vue?vue&type=style&index=0&id=45ba02c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports